// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"9a491284","437":"cf7c934b","453":"874d65d5","741":"0431d6d0","898":"52df2a83"}[chunkId] + ".chunk.js";
};